import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useCurrentAdmin, useLogout } from '../../context/AuthContext';
import { useOrganization } from '../../hooks/useOrganization';

const NavContent = ({ setMenuState }) => {
  const currentAdmin = useCurrentAdmin();
  const logout = useLogout();
  const navigate = useNavigate();
  const location = useLocation();
  const { data: orgData } = useOrganization({ enabled: !!currentAdmin });

  const handleContact = () => {
    setMenuState(false);
    if (location.pathname === '/') {
      setTimeout(() => {
        document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      navigate('/');
      setTimeout(() => {
        document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    }
  };

  const handleLogout = () => {
    logout();
    setMenuState(false);
  };

  return (
    <nav className="sidebar-nav">
      <div className="nav-links">
        <Link to="/" onClick={() => setMenuState(false)}>Home</Link>

        {!currentAdmin ? (
          <>
            <Link to="/signup" onClick={() => setMenuState(false)}>Signup</Link>
            <Link to="/login" onClick={() => setMenuState(false)}>Login</Link>
          </>
        ) : (
          <>
            <Link to="/account" onClick={() => setMenuState(false)}>Account</Link>
            <button onClick={handleContact} className="nav-link-btn">Contact</button>
            <Link to="/dashboard" onClick={() => setMenuState(false)}>Dashboard</Link>
            {orgData?.organization && (
              <Link to="/org-dashboard" onClick={() => setMenuState(false)}>All Locations</Link>
            )}
          </>
        )}
        <Link to="/faq" onClick={() => setMenuState(false)}>FAQ</Link>
        {currentAdmin && (
          <button onClick={handleLogout} className="logout-btn">Logout</button>
        )}
      </div>
      <div className="nav-footer">
        <p>&copy; 2026 Live Digital Menus &middot; Built by Annalise</p>
      </div>
    </nav>
  );
};

export default NavContent; 